import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
	const location = useLocation();

	useEffect(() => {
		// If the page wants to handle scrolling itself, do nothing.
		if (location.state?.skipScrollToTop) {
			return;
		}

		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "auto",
		});
	}, [location.pathname]);

	return null;
};

export default ScrollToTop;
